import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    gender: '',
    created_at_from: '',
    created_at_to: '',
    birthday_from: '',
    birthday_to: '',
  },
}

export const parentsUI = createSlice({
  name: 'parentsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setGender: (state, { payload }) => {
      state.tableFilters.gender = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    setBirthdayFromDate: (state, { payload }) => {
      state.tableFilters.birthday_from = payload
    },
    setBirthdayToDate: (state, { payload }) => {
      state.tableFilters.birthday_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setGender,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  trackActiveFilters,
  clearAllFilters,
} = parentsUI.actions

export default parentsUI.reducer
